const storyTypes = {
    GET_ALL_STORY : "GET_ALL_STORY",
    GET_STORY : "GET_STORY",
    ADD_STORY:"ADD_STORY",
    REMOVE_STORY:"REMOVE_STORY",
    NEW_STORY:"NEW_STORY",
    DELETE_IMAGE:"DELETE_IMAGE"
   }
   export default storyTypes;